import * as React from 'react';
import { magazine } from '../../../../helpers/routes';
import RegionalContent from './RegionalContent';

const mainText =
  'italist (이탈리스트)에서는, 이탈리스트와 긴밀한 관계를 유지하고 있는 이태리 현지 부티크에서 판매되고 있는 최고의 \
  명품 브랜드를 직접 구입할 수 있습 니다. 다른 곳에서는 찾을 수없는 한정판 아이템과 최신 컬렉션을 찾을 수 있을 뿐만 \
  아니라 평균 시세보다 30 % 저렴한 가격 혜택을 누릴 수 있습니다. 이 탈리스트에서 판매되고 있는 모든 아이템은 100 % \
  정품이며 신상품입니다. 대한민국으로도 배송되고 있습니다.';
const actionHref = `${magazine}how-to-buy-on-italist-korean/`;
const actionText = 'italist에 대해 더 알아보기<';

export default () => <RegionalContent actionHref={actionHref} actionText={actionText} mainText={mainText} />;
